<template>
  <div id="profileThree"></div>
</template>

<script>
export default {
  name: "ProfileThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        name: "Jane Smith",
        title: "Product Designer",
        bio: "Passionate about creating intuitive user experiences that drive business growth.",
        chip: "Meet the Team",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    getInitials(name) {
      return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    },
    render() {
      const el = document.getElementById("profileThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const nameSize = exporting ? 72 : 72 * this.scale;
      const titleSize = exporting ? 30 : 30 * this.scale;
      const bioSize = exporting ? 26 : 26 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;
      const avatarSize = exporting ? 200 : 200 * this.scale;
      const initialsSize = exporting ? 72 : 72 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Decorative large initial in background -->
          <div style="
            position: absolute;
            top: -80px;
            right: -40px;
            font-size: 500px;
            font-family: 'Playfair Display', 'Georgia', serif;
            font-weight: 900;
            color: #000000;
            opacity: 0.03;
            line-height: 1;
            pointer-events: none;
          ">${this.data.name.charAt(0)}</div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1; display: flex; gap: 48px; align-items: flex-end;">
            <!-- Avatar/Initials -->
            <div style="
              width: ${avatarSize}px;
              height: ${avatarSize}px;
              background: #1a1a1a;
              border-radius: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            ">
              <span style="
                font-size: ${initialsSize}px;
                font-family: 'Playfair Display', 'Georgia', serif;
                font-weight: 700;
                color: #ffffff;
              ">${this.getInitials(this.data.name)}</span>
            </div>

            <!-- Text Content -->
            <div style="flex: 1;">
              <!-- Title -->
              <div style="
                font-size: ${titleSize}px;
                font-weight: 600;
                color: ${primaryColor};
                margin-bottom: 8px;
                text-transform: uppercase;
                letter-spacing: 0.1em;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
              ">${this.data.title}</div>

              <!-- Name -->
              <div style="
                font-size: ${nameSize}px;
                font-family: 'Playfair Display', 'Georgia', serif;
                font-weight: 700;
                color: #1a1a1a;
                margin-bottom: 16px;
                line-height: 1.1;
                position: relative;
              ">${this.data.name}
                <span style="
                  position: absolute;
                  bottom: -8px;
                  left: 0;
                  width: 80px;
                  height: 4px;
                  background: ${primaryColor};
                "></span>
              </div>

              <!-- Bio -->
              <div style="
                font-size: ${bioSize}px;
                font-weight: 400;
                color: #666666;
                line-height: 1.5;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
                margin-top: 24px;
              ">${this.data.bio}</div>

              <!-- Chip -->
              <div style="margin-top: 32px;">
                <span
                  style="
                    display: inline-block;
                    background: #1a1a1a;
                    color: #ffffff;
                    font-size: ${chipSize}px;
                    font-weight: 600;
                    border-radius: 4px;
                    padding: 12px 20px;
                    letter-spacing: 0.08em;
                    text-transform: uppercase;
                    font-family: 'Inter', 'Helvetica Neue', sans-serif;
                  "
                >
                  ${this.data.chip}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
